import { IState } from '../../store';

export function selectHeatIndex(state: IState): number | null {
  return state.offerData.bti?.houseData?.heatIndex ?? null;
}
